module.exports = __webpack_public_path__ + "media/images/front/pharma_inquiry/no_image_mr-f9a5663281672013070e7c33e71dabc9.png";